import {ReactNode} from 'react';
import styled, {css} from 'styled-components';

export interface IButtonProps {
  children: ReactNode;
  // brandOutline?: boolean;
  // primary?: boolean;
  // primaryOutline?: boolean;
  // secondary?: boolean;
}

const buttonDefaultStyles = css`
  display: flex;
  cursor: pointer;
  justify-content: center;
`;

export const BrandOutlineButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.white.base};
  color: ${props.theme.colors.goBrand.orange};
  border: 1px solid ${props.theme.colors.goBrand.orange};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
`,
);

export const PrimaryButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goBrand.blue};
  color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.base};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const SecondaryButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  height: 42px;
  background-color: ${props.theme.colors.white.base};
  color: ${props.theme.colors.black.base};
  border: none;
  font-weight: bold;
  border-radius: ${props.theme.misc.borderRadius.base};
  align-items: center;
`,
);

export const PrimaryOutlineButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.white.base};
  color: ${props.theme.colors.goBrand.blue};
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.base};
  border: 1px solid ${props.theme.colors.goBrand.blue};
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const Button = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  min-width:${props.minWidth}
  background-color: ${props.theme.colors.goBrand.orange};
  color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
  &.disabled {
    background: #e1e1e1;
    cursor: not-allowed;
    pointer-events: none;
  }
`,
);

export const ButtonDefault = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: #898b91;
  color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
  &.disabled {
    background: #e1e1e1;
    cursor: not-allowed;
    pointer-events: none;
  }
`,
);
